import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

export const GridContainer = styled(Grid)`
    display: flex;
    margin-left: 30%;
    width: 40%;
    height: 74vh;
    justify-content: center;
    flex-direction: column;
`;